module.exports = __webpack_public_path__ + "static/media/GeneralInstructions.ef2f6c75.svg";